import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import ArticleCreateForm from "../components/ArticleCreateForm";
import useTitle from "../components/Title";

const NewsAdmin = () => {
  useTitle("- News Admin");

  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">
          <ArticleCreateForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewsAdmin;
